import React, { memo } from 'react';
// Mui
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

function SelectAutoComplete(props) {
  const { options, selectedOption, setSelectedOption } = props;
  const { label, disabled = false, required = false, onChange = undefined } = props;
  const { textField = 'description', getOptionLabel } = props;

  return (
    <Autocomplete
      options={options}
      getOptionLabel={getOptionLabel !== undefined ? getOptionLabel : (item) => item[textField]}
      disabled={disabled}
      renderInput={(params) => (
        <TextField {...params} label={label} margin="normal" required={required} />
      )}
      value={selectedOption || null}
      onChange={(_, item) => {
        if (item === null) {
          setSelectedOption(undefined);
        } else {
          setSelectedOption(item);
        }
        if (onChange !== undefined) {
          onChange(item ?? undefined);
        }
      }}
    />
  );
}

export default memo(SelectAutoComplete);
